<template>
	<section class="main">
		<header class="panel-heading">
			<h3 class="panel-title">其他違規/獎勵</h3>
		</header>
		<div class="panel-collapse">
			<div class="panel-body">
				<div class="row form-group" >
					<div class="col-md-12 text-right form-inline">
						<button v-if="isAdmin('stay') || sessionData.isRoomMage == 'Y'" class="btn btn-danger m-xs" @click="gotoView('stay.violateEdit',{editType:'N'})">新增違規/獎勵紀錄</button>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<table class="table table-no-more table-bordered table-striped mb-none" >
							<thead>
								<tr>
									<th class="text-center" width="8%"></th>
									<th class="text-center" width="8%">學期</th>
									<th class="text-center" width="10%">學制</th>
									<th class="text-center" width="16%">系科年級</th>
									<th class="text-center" width="8%">學號</th>
									<th class="text-center" width="8%">姓名</th> 
									<th class="text-center" width="10%">違規概況</th>
									<th class="text-center" width="10%">(扣)點數</th> 
									<th class="text-center" width="16%">記錄日期</th> 
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in violateRecordGrid.rows" :key="index">
									<td data-title="" class="text-center">
										<a v-if="!item.violatePoint && item.crUser == sessionData.account" href="javascript:;" class="btn-link" @click="deleteViolate(item)">刪除</a>
									</td>
									<td data-title="學期" class="text-center">{{item.smtr}}</td>
									<td data-title="學制" class="text-center">{{item.deptSsymStr}}</td>
									<td data-title="系科年級" class="text-center">
										<span v-if="item.deptCode">{{item.deptCodeStr}}-{{item.drade}}年{{item.dradeClass}}班</span>
									</td>
									<td data-title="學號" class="text-center">{{item.account}}</td>
									<td data-title="姓名" class="text-center">{{item.name}}</td>
									<td data-title="違規概況" class="text-center">
										<a href="javascript:;" class="btn-link" @click="gotoView('stay.violateEdit', {editType:'E', sno:item.sno, account:item.account})">
											{{item.violateName}}
										</a>
									</td>
									<td data-title="(扣)點數" class="text-center">
										<span v-if="!item.violatePoint">--</span>
										<span v-else>{{item.violatePoint}}</span>
									</td>
									<td data-title="記錄日期" class="text-center">{{customFormatter(item.crDate, "YYYY/MM/DD HH:mm:ss")}}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12">
						<div class="text-center" >
							<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	components:{
	},
	data(){
		return {
			smtr:"",
			violateRecordGrid:{},
			page:1,
			pageSize:10,
			totalPage:0,
			isShowPopup:false,
		}
	},
	mounted(){
		this.smtr = this.nowSmtr;
		this.gridInit();
	},
	methods:{
		updateGrid(page) {
			//更新Grid 必需
			this.page = page;
			this.gridInit();
		},
		gridInit(){
			let param = {
				page:this.page,
				pageSize:this.pageSize,
				model:{
					// smtr:this.smtr,
					revokeApply:"N"
				}
			};
			if(this.sessionData.accountType == "STU" && this.sessionData.isRoomMage == "Y"){
				param.model["mageAccount"] = this.sessionData.account;
			}else if(this.sessionData.accountType == "STU" && this.sessionData.isRoomMage != "Y"){
				param.model["account"] = this.sessionData.account;
			}
			const api = "/api/Violate/violateRecordGrid";
			this.$axios.post(api, JSON.stringify(param)).then(resp =>{
				this.violateRecordGrid = resp.data.data;
				this.totalPage = this.violateRecordGrid.total
				this.page = this.violateRecordGrid.page;
				this.pageSize = this.violateRecordGrid.pageSize;
			});
		},
		selectYear(){
			let smtrArray = [];
			let nowYear = (new Date().getFullYear() - 1911);
			let nowMonth = new Date().getMonth() + 1;
			if(nowMonth < 8){
				nowYear = nowYear-1;
			}
			for(let y = nowYear; y > 100 ; y--){
				if((y == nowYear && nowMonth < 8) || y < nowYear){
					smtrArray.push({text:y+"年第二學期",value:y+"2"});
				}
				smtrArray.push({text:y+"年第一學期",value:y+"1"});
			}
			return smtrArray;
		},
		deleteViolate(item){
			let _this = this;
			bootbox.confirm("確定刪除此筆違規記錄?", function(result){
				if(result){
					const api = `/api/Violate/delViolateRecord/${item.sno}`;
					_this.$axios.delete(api).then(resp =>{
						_this.gridInit();
					});
				}
			})
			
		},
		showPopupControl(isShowPopup){
			this.isShowPopup = isShowPopup;
		},
	}
}
</script>